import { USER_ROLES } from './index';

export const PLG_MODE = process.env.REACT_APP_PLG_MODE === 'true';
export const SALES_DASHBOARD_PATH = '/';
export const SALES_JOB_QUERY_PATH = '/job-query';
export const PLG_APP_URL =
  process.env.REACT_APP_PLG_APP_URL || 'https://plg.wisedoc.io';
export const normalizeSalesJobId = (value: string) =>
  value.trim().toUpperCase();

export const getTeamRolesForOrganization = (
  isSalesDashboardAccessOrg: boolean | null | undefined,
) =>
  isSalesDashboardAccessOrg
    ? [USER_ROLES.ROOT_USER, USER_ROLES.ADMIN, USER_ROLES.SALES]
    : [USER_ROLES.ROOT_USER, USER_ROLES.ADMIN, USER_ROLES.RECRUITER];

export const getAssignableTeamRolesForOrganization = (
  isSalesDashboardAccessOrg: boolean | null | undefined,
) =>
  isSalesDashboardAccessOrg
    ? [USER_ROLES.ADMIN, USER_ROLES.SALES]
    : [USER_ROLES.ADMIN, USER_ROLES.RECRUITER];

export const getDefaultInvitableTeamRole = (
  isSalesDashboardAccessOrg: boolean | null | undefined,
) => (isSalesDashboardAccessOrg ? USER_ROLES.SALES : USER_ROLES.RECRUITER);
